module.exports = __webpack_public_path__ + "static/media/server.5a4d066f.gif";